import React, { createElement } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  FilledInput,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  InputLabel,
  makeStyles,
  Menu,
  MenuItem,
  Switch,
} from '@material-ui/core'
import MoreHorizIcon from '@material-ui/icons/MoreHoriz'
import { setTextArrayElement } from '../../../features/State Management/questionSlice'
import useLocale from '../../../customHooks/useLocale'
import {
  getLocalizedValue,
  setLocalizedValue,
} from '../../../utils/localeUtils'

const useStyles = makeStyles((theme) => ({
  menuItem: {
    outline: 'none',
  },
}))

const EachOptionMenu = ({ propertyName, index }) => {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleMenuClose = () => {
    setAnchorEl(null)
  }
  return (
    <>
      <IconButton size='small' onClick={handleMenuClick}>
        <MoreHorizIcon />
      </IconButton>
      <Menu
        id='simple-menu'
        // keepMounted
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <div>
          <MenuElements propertyName={propertyName} index={index} />
        </div>
      </Menu>
    </>
  )
}

export default EachOptionMenu

/* ----- USED IN EachOptionMenu BELOW ----- */

const NumericValueMenuItem = ({ propertyName, index }) => {
  const option = useSelector((state) => state.question[propertyName][index])
  const dispatch = useDispatch()
  const classes = useStyles()
  return (
    <MenuItem className={classes.menuItem} button={false}>
      <FormControl fullWidth>
        <InputLabel variant='filled'>Numeric value</InputLabel>
        <FilledInput
          required
          autoFocus
          autoComplete='off'
          type='number'
          placeholder='Enter an integer (or a float)..'
          value={option['numeric_value'] || ''}
          onChange={(e) =>
            dispatch(
              setTextArrayElement({
                property: propertyName,
                index: index,
                value: {
                  ...option,
                  numeric_value: Number(e.target.value),
                },
              })
            )
          }
          endAdornment={
            <InputAdornment position='end'>
              <Switch
                color='primary'
                // id={`tooltip-switch`}
                // checked={open}
                // onClick={handleClick}
              />
            </InputAdornment>
          }
        />
      </FormControl>
    </MenuItem>
  )
}

const OptionTooltipMenuItem = ({ propertyName, index }) => {
  const option = useSelector((state) => state.question[propertyName][index])
  const dispatch = useDispatch()
  const classes = useStyles()
  const locale = useLocale()

  const value = getLocalizedValue(option['tooltip'], locale)

  return (
    <MenuItem className={classes.menuItem} button={false}>
      <FormControl fullWidth>
        <InputLabel variant='filled'>Option tooltip</InputLabel>
        <FilledInput
          required
          autoFocus
          autoComplete='off'
          type='text'
          placeholder='Enter option tooltip text here..'
          value={value || ''}
          onChange={(e) =>
            dispatch(
              setTextArrayElement({
                property: propertyName,
                index: index,
                value: {
                  ...option,
                  tooltip: setLocalizedValue(
                    option['tooltip'],
                    e.target.value,
                    locale
                  ),
                },
              })
            )
          }
          endAdornment={
            <InputAdornment position='end'>
              <Switch
                color='primary'
                // id={`tooltip-switch`}
                // checked={open}
                // onClick={handleClick}
              />
            </InputAdornment>
          }
        />
      </FormControl>
    </MenuItem>
  )
}

const StopSubscriptionMenuItem = ({ propertyName, index }) => {
  const option = useSelector((state) => state.question[propertyName][index])
  const dispatch = useDispatch()
  const classes = useStyles()
  return (
    <MenuItem className={classes.menuItem} button={false}>
      <FormControlLabel
        style={{ userSelect: 'none' }}
        label='Stop subscription'
        control={
          <Switch
            checked={option['stop_subscription'] || false}
            color='primary'
            onChange={(e) =>
              dispatch(
                setTextArrayElement({
                  property: propertyName,
                  index: index,
                  value: {
                    ...option,
                    stop_subscription: e.target.checked,
                  },
                })
              )
            }
          />
        }
      />
    </MenuItem>
  )
}

const menuElementsByType = {
  checkbox: [OptionTooltipMenuItem, StopSubscriptionMenuItem],
  radio: [
    OptionTooltipMenuItem,
    StopSubscriptionMenuItem,
    NumericValueMenuItem,
  ],
  likert: [NumericValueMenuItem],
  dropdown: [NumericValueMenuItem],
}

const MenuElements = ({ propertyName, index }) => {
  const type = useSelector((state) => state.question.type)
  return menuElementsByType[type].map((e, i) =>
    createElement(e, { propertyName, index, key: i }, null)
  )
}
